// src/CircleLoader.tsx
import * as React from "react";
var CircleLoader = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: props.size * 1.25,
    height: props.size,
    viewBox: "0 0 20 16",
    fill: props.color,
    style: props.style,
    role: props.role,
    className: props.className
  },
  /* @__PURE__ */ React.createElement("path", { d: "M7.93 15.73a8 8 0 0 0 8.42-2.86c1.97-2.56 2.2-6.07.58-8.87A7.995 7.995 0 0 0 8.96.07a8.012 8.012 0 0 0-6.69 5.86c-.04.15-.06.3-.04.45.02.15.06.3.14.43.07.13.18.25.3.34.12.09.26.16.41.2a1.144 1.144 0 0 0 .88-.12c.13-.08.25-.18.34-.3.09-.12.16-.26.19-.41.29-1.09.9-2.07 1.75-2.82s1.9-1.22 3.02-1.37a5.717 5.717 0 0 1 5.28 9.15c-.69.9-1.63 1.57-2.7 1.93-1.07.36-2.22.4-3.32.11-.15-.04-.3-.06-.45-.04-.15.02-.3.06-.43.14-.13.07-.25.18-.34.3-.09.12-.16.26-.2.41a1.144 1.144 0 0 0 .12.88c.08.13.18.25.3.34.12.08.26.14.41.18z" })
);
CircleLoader.displayName = "CircleLoader";
export {
  CircleLoader
};
